import '../jquery'

let ready_legacy_user;

ready_legacy_user = function () {
  //  $("#user_country").change ->
  //    if $('#user_country').selectpicker('val') == "LV" && $("input[name='user[person_type]']:checked", "#cart").val() == "private_person"
  //      $(".user_identity_number").show()
  //    else
  //      $(".user_identity_number").hide()
  //      $("#user_identity_number").val("")
  return $(".manager_customer_person_type input").change(function () {
    if ($(this).val() === "legal_person") {
      $(".user_legal_person_details").show();
      $(".user_identity_number").hide();
      return $("#user_identity_number").val("");
    } else {
      $(".user_legal_person_details").hide();
      $("#manager_customer_attributes_reg_nr").val("");
      $("#manager_customer_attributes_vat_number").val("");
      return $(".user_identity_number").show();
    }
  });
};

$(document).ready(ready_legacy_user);

$(document).on('turbo:load', ready_legacy_user);